import { TextInputValidationFn } from '@Shared/Components/Inputs/TextInput/TextInput'

export const addZipCodeDash = (zipCode: string, country: string) => {
  let firstSetBeforeDash
  switch (country) {
    case 'PT':
      firstSetBeforeDash = 4
      break
    case 'PL':
      firstSetBeforeDash = 2
      break
    case 'BR':
      firstSetBeforeDash = 5
      break
    case 'JP':
      firstSetBeforeDash = 3
      break
    default:
      return zipCode
      break
  }
  if (zipCode.length > firstSetBeforeDash && !zipCode.includes('-')) {
    return `${zipCode.substring(0, firstSetBeforeDash)}-${zipCode.substring(firstSetBeforeDash)}`
  }
  return zipCode
}

const validateZip: (text, countryCode) => string = (text, countryCode) => {
  let regex
  switch (countryCode) {
    case 'AT':
      regex = /^\b\d{4}$/
      return regex.test(text)
    case 'BE':
      regex = /^\b\d{4}$/
      return regex.test(text)
    case 'BG':
      regex = /^\b\d{4}$/
      return regex.test(text)
    case 'CH':
      regex = /^\b\d{4}$/
      return regex.test(text)
    case 'NZ':
      regex = /^\b\d{4}$/
      return regex.test(text)
    case 'AU':
      regex = /^\b\d{4}$/
      return regex.test(text)
    case 'LV':
      regex = /^\b\d{4}$/
      return regex.test(text)
    case 'DK':
      regex = /^\b\d{4}$/
      return regex.test(text)
    case 'HU':
      regex = /^\b\d{4}$/
      return regex.test(text)
    case 'CY':
      regex = /^\b\d{4}$/
      return regex.test(text)
    case 'SI':
      regex = /^\b\d{4}$/
      return regex.test(text)
    case 'LU':
      regex = /^\b\d{4}$/
      return regex.test(text)
    case 'NO':
      regex = /^\b\d{4}$/
      return regex.test(text)
    case 'DE':
      regex = /^\b\d{5}$/
      return regex.test(text)
    case 'ES':
      regex = /^\b\d{5}$/
      return regex.test(text)
    case 'GR':
      regex = /^\b\d{3}\s\d{2}$|^\b\d{5}$/
      return regex.test(text)
    case 'FI':
      regex = /^\b\d{5}$/
      return regex.test(text)
    case 'TR':
      regex = /^\b\d{5}$/
      return regex.test(text)
    case 'TH':
      regex = /^\b\d{5}$/
      return regex.test(text)
    case 'ID':
      regex = /^\b\d{5}$/
      return regex.test(text)
    case 'IT':
      regex = /^\b\d{5}$/
      return regex.test(text)
    case 'LT':
      regex = /^\b\d{5}$/
      return regex.test(text)
    case 'MY':
      regex = /^\b\d{5}$/
      return regex.test(text)
    case 'FR':
      regex = /^\b\d{5}$/
      return regex.test(text)
    case 'EE':
      regex = /^\b\d{5}$/
      return regex.test(text)
    case 'HR':
      regex = /^\b\d{5}$/
      return regex.test(text)
    case 'US':
      regex = /^\b\d{5}$/
      return regex.test(text)
    case 'SE':
      regex = /^\b\d{3}\s\d{2}$|^\b\d{5}$/
      return regex.test(text)
    case 'NL':
      regex = /^\b\d{4}\s?[a-zA-Z]{2}$/
      return regex.test(text)
    case 'RO':
      regex = /^\b\d{6}$/
      return regex.test(text)
    case 'RU':
      regex = /^\b\d{6}$/
      return regex.test(text)
    case 'CN':
      regex = /^\b\d{6}$/
      return regex.test(text)
    case 'SG':
      regex = /^\b\d{6}$/
      return regex.test(text)
    case 'CA':
      regex = /^\b[a-zA-Z]{1}\d{1}[a-zA-Z]{1}\s?\d{1}[a-zA-Z]{1}\d{1}$/
      return regex.test(text)
    case 'GB':
      // eslint-disable-next-line no-case-declarations
      let isValid = false
      // eslint-disable-next-line no-case-declarations
      const validations = [
        /^\b[a-zA-Z]{1,2}\d{1,2}\s?\d{1}[a-zA-Z]{2}$/,
        /^\b[a-zA-Z]{1,2}\d{1}[a-zA-Z]{1}\s?\d{1}[a-zA-Z]{2}$/,
      ]
      validations.forEach((reg) => {
        if (reg.test(text)) {
          isValid = true
          return
        }
      })
      return isValid
    case 'IE':
      regex = /^\b\w{3}\s?\w{4}$/
      return regex.test(text)
    case 'SK':
      regex = /^\b\d{3}\s\d{2}$|^\b\d{5}$/
      return regex.test(text)
    case 'PT':
      regex = /^\b\d{4}-\d{3}$/
      return regex.test(text)
    case 'PL':
      regex = /^\b\d{2}-\d{3}$/
      return regex.test(text)
    case 'CZ':
      regex = /(^\b\d{3}\s\d{2}$|^\b\d{5}$)/
      return regex.test(text)
    case 'BR':
      regex = /^\b\d{5}-\d{3}$/
      return regex.test(text)
    case 'MX':
      regex = /^\b\d{5}$/
      return regex.test(text)
    case 'IS':
      regex = /^\b\d{3}$/
      return regex.test(text)
    case 'IL':
      regex = /^\b\d{7}$/
      return regex.test(text)
    case 'JP':
      regex = /^\b\d{3}-\d{4}$/
      return regex.test(text)
    case 'KR':
      regex = /^\b\d{5}$/
      return regex.test(text)
    default:
      regex = /^.{4,}$/
      return regex.test(text)
  }
}

const getValidFormat = (country) => {
  switch (country) {
    case 'AT':
      return '1234'
    case 'BE':
      return '1234'
    case 'BG':
      return '1234'
    case 'CH':
      return '1234'
    case 'NZ':
      return '1234'
    case 'AU':
      return '1234'
    case 'LV':
      return '1234'
    case 'DK':
      return '1234'
    case 'HU':
      return '1234'
    case 'CY':
      return '1234'
    case 'SI':
      return '1234'
    case 'LU':
      return '1234'
    case 'NO':
      return '1234'
    case 'DE':
      return '12345'
    case 'ES':
      return '12345'
    case 'GR':
      return '123 45, 12345'
    case 'FI':
      return '12345'
    case 'TR':
      return '12345'
    case 'TH':
      return '12345'
    case 'ID':
      return '12345'
    case 'IT':
      return '12345'
    case 'LT':
      return '12345'
    case 'MY':
      return '12345'
    case 'FR':
      return '12345'
    case 'EE':
      return '12345'
    case 'HR':
      return '12345'
    case 'US':
      return '12345'
    case 'SE':
      return '123 45, 12345'
    case 'NL':
      return '1234AB or 1234 AB'
    case 'RO':
      return '123456'
    case 'RU':
      return '123456'
    case 'CN':
      return '123456'
    case 'SG':
      return '123456'
    case 'CA':
      return 'A1B 2C3 or A1B2C3'
    case 'GB':
      return 'A1 2BC, A12 3BC, AB1 2CD, AB12 3CD, A1B 2CD, A1B 2CD, or AB1C 2DE'
    case 'IE':
      return 'XXX XXXX or XXXXXXX'
    case 'SK':
      return '123 45, 12345'
    case 'PT':
      return '1234-567'
    case 'PL':
      return '12-345'
    case 'CZ':
      return '12345 or 123 45'
    case 'BR':
      return '12345-678'
    case 'MX':
      return '12345'
    case 'IS':
      return '123'
    case 'IL':
      return '1234567'
    case 'JP':
      return '123-4567'
    case 'KR':
      return '12345'
    default:
      return '1234'
  }
}

export const ZipCodeValidationV2: (countryCode: string | null | undefined, t) => TextInputValidationFn
    = (countryCode, t) => (value: string | null | undefined) => {
      const valid = validateZip(value?.trimEnd(), countryCode)
      const stringValue = value?.trimEnd() || ''
      const incorrectName = /\s{2}/.test(stringValue) || stringValue.startsWith(' ') || stringValue.endsWith(' ')

      if (valid && !incorrectName) {
        return { success: true, errorMessage: '' }
      }
      return {
        errorMessage: `${t('checkout:INPUT_FIELD_ZIPCODE_FORMAT_IS_INVALID')}: ${getValidFormat(countryCode)}`,
        success: false,
      }
    }
